import { render, staticRenderFns } from "./BookFilter.vue?vue&type=template&id=9fbdfa22&scoped=true&"
import script from "./BookFilter.vue?vue&type=script&lang=js&"
export * from "./BookFilter.vue?vue&type=script&lang=js&"
import style0 from "./BookFilter.vue?vue&type=style&index=0&id=9fbdfa22&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9fbdfa22",
  null
  
)

export default component.exports